if (!customElements.get("s-brands")) {
  customElements.define(
    "s-brands",
    class SectioBrands extends HTMLElement {
      constructor() {
        super();

      }

      connectedCallback() {
        this.listWrapper = this.querySelector(".js-brands__list-wrapper")
        this.swiper = new Swiper(this.listWrapper, {
          slidesPerView: "auto",
          spaceBetween: 30,
          speed: 400,
          breakpoints: {
            768: {
              spaceBetween: 60
            }
          }
        })
      }

      disconnectedCallback() {
      }
    }
  );
}
